import React, { useState, useMemo, useEffect } from "react";
import phone from "../../assets/phone.png";
import CalendarContent from "../AdvertisingCard/components/CalendarContent";
import CardsAvantiImageGallery from "../AdvertisingCard/components/CardsAvantiImageGallery";

import {
  StyledChanceCardContainer,
  StyledPhoneImageModified,
  StyledTextContainer,
  StyledTitleText,
  StyledDescriptionText,
  StyledBadge,
  StyledPlanLink,
  Ellipse,
  StyledButton,
  StyledButtonText,
  StyledChanceCardDiv
} from "./styles"; 
import {
  DEFAULT_SUBSCRIPTION_LABEL_PLAN,
  ADIMPLENTE_RECORRENCY_LABEL_PLAN,
  TYPE_CARDS_AVANTI_HOMEPAGE,
  SPECIAL_PLAN,
  ADIMPLENTE_LUCKYNUMBERS_LABEL_PLAN,
  AVANTI_SITE_URL,
  PALMEIRASPAY_SITE_URL
} from "../../utils/consts";

const AdvertisingCard = (props) => {
  
  const { title, userData, description, buttonText, typeCard, allLoyaltyTypes} = props;
  const [buttonConfig, setButtonConfig] = useState({
    buttonText: "",
    buttonActive: false,
    redirectLink: false
  })
  const isAvanti = useMemo(() => {
    return userData?.PayAccountStatus__c && userData?.PayAccountStatus__c?.toLowerCase()?.includes("normal") ? true : false;
  }, [userData]);
  const nextPlan = useMemo(() => {
    if (userData?.LoyaltyCategory__c?.toLowerCase()?.includes(SPECIAL_PLAN)) return SPECIAL_PLAN;
    if (allLoyaltyTypes && allLoyaltyTypes.length > 0) {
      const currentIndex = allLoyaltyTypes.findIndex(type => type?.Name?.toLowerCase()?.includes(userData?.LoyaltyCategory__c?.toLowerCase()));
      if (currentIndex === -1) return allLoyaltyTypes[0];
      if (currentIndex !== -1 && currentIndex < allLoyaltyTypes.length - 1) {
        return allLoyaltyTypes[currentIndex + 1];
      }
    }
     return false;
  }, [userData, allLoyaltyTypes]);
  

  useEffect(() => {
    if (!nextPlan && typeCard === TYPE_CARDS_AVANTI_HOMEPAGE.AVANTICARD) {
      setButtonConfig({
        buttonText: DEFAULT_SUBSCRIPTION_LABEL_PLAN,
        buttonActive: true,
        redirectLink: AVANTI_SITE_URL
      });
      return;
    }
    const buttonLabel = renderButtonText(typeCard, nextPlan, userData?.LoyaltyPaymentType__c, buttonText, isAvanti);
    const buttonIsEnabled = buttonIsActive(typeCard, nextPlan, userData?.LoyaltyPaymentType__c, isAvanti);
    setButtonConfig({
      buttonText: buttonLabel,
      buttonActive: buttonIsEnabled,
      redirectLink: typeCard === TYPE_CARDS_AVANTI_HOMEPAGE.PALMEIRASPAY ? PALMEIRASPAY_SITE_URL : nextPlan?.Redirect__c
    });
  }, [isAvanti, nextPlan]);


  const renderElipseContent = (typeCard) => {
    switch (typeCard) {
      case "palmeirasPay":
        return (<><StyledPhoneImageModified src={phone} alt="kv01" />
          <StyledBadge>X2</StyledBadge></>
        )
      case "avantiCard":
        return <CardsAvantiImageGallery />;
      case "planCard":
        return <CalendarContent />;
      default:
        return <StyledPhoneImageModified src={phone} alt="kv01" />;
    }
  }

  

  const renderButtonText = (typeCard, nextPlan, recorrencyPlan, buttonText, isAvanti) => {
    switch (typeCard) {
      case TYPE_CARDS_AVANTI_HOMEPAGE.PALMEIRASPAY:
        return isAvanti ? buttonText?.labelIsAvanti : buttonText?.defaultLabel;
      case TYPE_CARDS_AVANTI_HOMEPAGE.AVANTICARD:
        return nextPlan === SPECIAL_PLAN
          ? ADIMPLENTE_LUCKYNUMBERS_LABEL_PLAN
          : "SEJA " + nextPlan?.Name + " E GANHE MAIS NÚMEROS DA SORTE";
      case TYPE_CARDS_AVANTI_HOMEPAGE.PLANCARD:
        return renderPlanRecurrencyLabel(recorrencyPlan);
      default:
        return "";
    }
  }
  const renderPlanRecurrencyLabel = (recurrencePlan) => {
    if (!recurrencePlan) return DEFAULT_SUBSCRIPTION_LABEL_PLAN;
    const recurrencyLabelPlan = (label) => {
      return `ASSINE O PLANO ${label} PARA GANHAR MAIS NÚMEROS DA SORTE`;
    };
    switch (recurrencePlan?.toLowerCase()) {
      case "plano mensal":
        return recurrencyLabelPlan("trimestral");
      case "plano trimestral":
        return recurrencyLabelPlan("semestral");
      case "plano semestral":
        return recurrencyLabelPlan("anual");
      case "plano anual":
        return ADIMPLENTE_RECORRENCY_LABEL_PLAN;
      default:
        return DEFAULT_SUBSCRIPTION_LABEL_PLAN;
    }
  }
   
  const buttonIsActive = (typeCard, nextPlan, recurrencePlan,  isAvanti) => {
    switch (typeCard) {
      case TYPE_CARDS_AVANTI_HOMEPAGE.PALMEIRASPAY:
        return isAvanti ? false : true;
      case TYPE_CARDS_AVANTI_HOMEPAGE.AVANTICARD:
        return nextPlan === SPECIAL_PLAN ? false : true;
      case TYPE_CARDS_AVANTI_HOMEPAGE.PLANCARD:
        return recurrencePlan === "Plano Anual" ? false : true;
      default:
        return false;
    } 
  }
  return (
    <StyledChanceCardContainer>
   <StyledChanceCardDiv>
      <Ellipse>
        {renderElipseContent(typeCard)}
      </Ellipse>
      <StyledTextContainer>
        <StyledTitleText>{title}</StyledTitleText>
        <StyledDescriptionText>
          {description}
        </StyledDescriptionText>
      </StyledTextContainer>
    </StyledChanceCardDiv>
      {typeCard && typeCard === TYPE_CARDS_AVANTI_HOMEPAGE.AVANTICARD && (
        <StyledPlanLink onClick={() => props.handleModalOpen(true)}>ver pontos do plano</StyledPlanLink>
      )}
      <StyledButton
        buttonActive={buttonConfig?.buttonActive}
        onClick={() => {
          if (buttonConfig?.redirectLink && buttonConfig?.buttonActive) {
            window.open(buttonConfig.redirectLink, '_blank');
          }
        }}>
        <StyledButtonText>{buttonConfig?.buttonText?.toLocaleUpperCase()}</StyledButtonText>
      </StyledButton>
    </StyledChanceCardContainer>
  );
};

export default AdvertisingCard;
